import Projects from "../Projects/Projects";

const reactProjectsList = [
  {
    id: "nxttrendz",
    displayText: "Nxt Trendz",
    imageUrl:
      "https://assets.ccbp.in/frontend/react-js/nxt-trendz-login-img.png",
    gitHubUrl: "https://github.com/harikrishnaalvala/trendzs-app.git",
    liveDemoUrl: "https://martzhk.ccbp.tech",
  },
  {
    id: "nxtWatch",
    displayText: "NxtWatch",
    imageUrl:
      "https://res.cloudinary.com/dhaj9wlmu/image/upload/v1704013712/download_1_mphjvj.png",
    gitHubUrl: "https://github.com/harikrishnaalvala/nxtwatch.git",
    liveDemoUrl: "https://nxtwatchhk.ccbp.tech/",
  },
  {
    id: "jobbyApp",
    displayText: "Jobby App",
    imageUrl:
      "https://res.cloudinary.com/dhaj9wlmu/image/upload/v1704013619/jobby-app-jobs-success-lg-output-v0_zk4y1q.png",
    gitHubUrl: "https://github.com/harikrishnaalvala/job-app.git",
    liveDemoUrl: "https://hkjobapp.ccbp.tech/",
  },
];

const ReactProjects = () => <Projects projectsList={reactProjectsList} />;

export default ReactProjects;
